import * as React from 'react';
import { namespacedClassnames, isPromise } from '../../../../common';
import { Tooltip } from '../../../../primitives/tooltip/tooltip';
import { Text } from '../../typography';
import { Icon, TinyLoader } from '../../../../primitives';
import { roundMediumAlert } from '../../../../icons';
import { keyCodes, classNames } from '@wix/answers-lib';
import { InlineControl } from '../common/inline-control/index';
import { isTextSelected } from '../common/utils';
export var inlineTextInputKey = 'inline-text-input';
export var InlineTextInput = function (props) {
    var value = props.value, onChange = props.onChange, isValueValid = props.isValueValid, className = props.className, ellipsis = props.ellipsis, defaultVal = props.defaultVal, texts = props.texts, valueRenderer = props.valueRenderer, hideClear = props.hideClear, customViewRenderer = props.customViewRenderer;
    var clear = texts.clear, placeholder = texts.placeholder, header = texts.header, focusedPlaceholder = texts.focusedPlaceholder;
    var initVal = value === '' && !!defaultVal ? defaultVal : value;
    var _a = React.useState(false), isFocused = _a[0], setIsFocused = _a[1];
    var _b = React.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var _c = React.useState(initVal), newValue = _c[0], setNewValue = _c[1];
    var _d = React.useState(initVal), unconfirmedValue = _d[0], setUnconfirmedValue = _d[1];
    var _e = React.useState(false), isLoading = _e[0], setIsLoading = _e[1];
    React.useEffect(function () {
        var maybeDefaultValue = value === '' && !!defaultVal ? defaultVal : value;
        setUnconfirmedValue(maybeDefaultValue);
    }, [value]);
    var onChangeInput = function (e) {
        var inputVal = e.target.value;
        setUnconfirmedValue(inputVal);
    };
    var onFocus = function () {
        if (!isTextSelected(window)) {
            setIsFocused(!props.disabled);
        }
    };
    var onLeaveFocus = function () {
        setIsLoading(false);
        setIsHovered(false);
        setIsFocused(false);
    };
    var onMouseOver = function () { return setIsHovered(true); };
    var onMouseLeave = function () { return setIsHovered(false); };
    var onBlur = function (e) {
        var validValue = isValueValid && isValueValid(unconfirmedValue);
        if (validValue) {
            var val = defaultVal || '';
            setUnconfirmedValue(val);
            var result = onChange(newValue, e);
            if (isPromise(result)) {
                result.then(onLeaveFocus, onLeaveFocus);
            }
            else {
                onLeaveFocus();
            }
        }
        else {
            onConfirm(e);
        }
    };
    var onConfirm = function (e) {
        e.preventDefault();
        var validValue = isValueValid && isValueValid(unconfirmedValue);
        if (!validValue) {
            var result = onChange(unconfirmedValue, e);
            if (isPromise(result)) {
                setIsLoading(true);
                result.then(onLeaveFocus, function () {
                    onLeaveFocus();
                    setUnconfirmedValue(value);
                });
            }
            else {
                onLeaveFocus();
            }
            setNewValue(unconfirmedValue);
        }
    };
    var onCancel = function (e) {
        e.preventDefault();
        onChange(newValue, e);
        onLeaveFocus();
        setUnconfirmedValue(value);
    };
    var onClear = function (e) {
        e.preventDefault();
        var val = defaultVal || '';
        setUnconfirmedValue(val);
    };
    var onKeyPress = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        switch (e.keyCode) {
            case keyCodes.enter:
                onConfirm(e);
                break;
            case keyCodes.escape:
                onCancel(e);
                break;
            default:
                return;
        }
    };
    var resetSelectionRange = function (e) {
        return e.target.setSelectionRange(unconfirmedValue.length, unconfirmedValue.length);
    };
    var cn = namespacedClassnames(inlineTextInputKey, className, {
        'input-error': isValueValid && isValueValid(unconfirmedValue) && unconfirmedValue,
        'preserve-layout': props.preserveContentLayout,
        focused: isFocused
    });
    var focusedBody = function () {
        var focusedClassname = classNames('focused-body', { ellipsis: ellipsis && value, loading: isLoading });
        var validValue = isValueValid && isValueValid(unconfirmedValue);
        var errorIcon = validValue && unconfirmedValue ? (React.createElement(Tooltip, { relativeToBody: true, className: 'inline-text-error', body: validValue },
            React.createElement(Icon, { icon: roundMediumAlert }))) : null;
        var maybeHeader = header ? (React.createElement("div", { className: 'title-container' }, typeof header === typeof '' ? React.createElement(Text, { color: 't30', type: 'ht' }, header) : header)) : null;
        var inlineControl = (React.createElement(InlineControl, { onClear: onClear, onConfirm: onConfirm, onCancel: onCancel, disabledClear: !unconfirmedValue, disabledConfirm: !!validValue, clearText: clear, hideClear: hideClear }));
        return (React.createElement("div", { className: focusedClassname },
            maybeHeader,
            React.createElement("div", { className: 'input-container' },
                React.createElement("input", { value: unconfirmedValue, placeholder: focusedPlaceholder || placeholder, onChange: onChangeInput, onKeyDown: onKeyPress, autoFocus: true, onFocus: resetSelectionRange, disabled: isLoading }),
                isLoading ? React.createElement("div", { className: 'loader-wrapper' },
                    React.createElement(TinyLoader, null)) : errorIcon),
            !isLoading ? inlineControl : null));
    };
    var unFocusedBody = function () {
        var unfocusedClassname = namespacedClassnames('unfocused-body', {
            ellipsis: ellipsis && value, disabled: !!props.disabled
        });
        var maybeHover = (isHovered && !props.disabled) ? React.createElement(Text, { color: 't60' }, placeholder) : React.createElement(Text, { color: 't50' }, '-');
        var textValue = (React.createElement(Text, { ellipsis: true, relativeToBody: true, direction: props.disabled ? 'bottom' : 'top', key: value }, value || maybeHover));
        var unfocusedValue = (React.createElement("div", { className: unfocusedClassname }, valueRenderer ? valueRenderer() : textValue));
        if (props.disabled) {
            return (React.createElement(Tooltip, { relativeToBody: true, body: props.disabled }, unfocusedValue));
        }
        else if (customViewRenderer) {
            return React.createElement("div", { className: 'custom-view' }, customViewRenderer());
        }
        else {
            return unfocusedValue;
        }
    };
    var fieldContent = props.preserveContentLayout ? (React.createElement(React.Fragment, null,
        unFocusedBody(),
        isFocused && focusedBody())) : (isFocused ? focusedBody() : unFocusedBody());
    return (React.createElement("div", { className: cn, onClick: onFocus, onBlur: onBlur, onMouseEnter: onMouseOver, onMouseLeave: onMouseLeave }, fieldContent));
};
//# sourceMappingURL=index.js.map